import { useEffect, useRef } from 'react';

/** Calls `onOnline` whenever the device regains network connectivity. */
export const useNetwork = ({ onOnline }) => {
  const onOnlineRef = useRef(onOnline);
  onOnlineRef.current = onOnline;

  useEffect(() => {
    const handleOnline = () => onOnlineRef.current?.();
    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, []);
};
